export default "__VITE_ASSET__C$IVaRm0__"